// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StrikethroughOutlinedSvg from "@ant-design/icons-svg/es/asn/StrikethroughOutlined";
import AntdIcon from '../components/AntdIcon';

var StrikethroughOutlined = function StrikethroughOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: StrikethroughOutlinedSvg
  }));
};

StrikethroughOutlined.displayName = 'StrikethroughOutlined';
export default React.forwardRef(StrikethroughOutlined);